// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../../assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../../assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../../assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.ReactSelectAutocomplete_scroll__KKW7L::-webkit-scrollbar {
  height: 8px;
}
.ReactSelectAutocomplete_scroll__KKW7L::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.ReactSelectAutocomplete_scroll__KKW7L::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .ReactSelectAutocomplete_label__2KLXs {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .ReactSelectAutocomplete_label__2KLXs label {
  text-transform: capitalize;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .ReactSelectAutocomplete_label__2KLXs label,
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .ReactSelectAutocomplete_label__2KLXs p {
  margin-bottom: 10px;
  font-size: 12px !important;
  line-height: 15px;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .ReactSelectAutocomplete_label__2KLXs p {
  color: var(--secondaryColor);
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .ReactSelectAutocomplete_labelError__I1AL9 {
  color: var(--errorColor);
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .ReactSelectAutocomplete_labelError__I1AL9 p {
  color: var(--errorColor);
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .ReactSelectAutocomplete_error__Ap51A {
  border-color: var(--errorColor);
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .ReactSelectAutocomplete_input__GnoFA {
  position: relative;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .ReactSelectAutocomplete_input__GnoFA .ReactSelectAutocomplete_icon__slq6j {
  position: absolute;
  z-index: 1;
  top: 50%;
  transform: translateY(-50%);
  -webkit-margin-start: 10px;
          margin-inline-start: 10px;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .ReactSelectAutocomplete_input__GnoFA .ReactSelectAutocomplete_icon__slq6j svg {
  width: 10px;
  height: 10px;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .ReactSelectAutocomplete_inputError__-22cR {
  border: 1px solid var(--errorColor);
  padding: 1px;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .ReactSelectAutocomplete_iconInput__nHvkz div[class*=control],
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .ReactSelectAutocomplete_iconInput__nHvkz div[class*=control],
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .ReactSelectAutocomplete_iconInput__nHvkz div[class*=control] {
  -webkit-padding-start: 25px;
          padding-inline-start: 25px;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od {
  /*     div[class*='ValueContainer'] {
        height: 30px;
        overflow-y: scroll;
        // padding: 0;
        @include Sm {
          height: max-content;
        }
      } */
  /*     div[class*='MenuList'] {
    padding: 0;
    background-color: var(--bgColor);
    div {
      background-color: var(--bgColor);
      color: var(--mainColor);
    }
  } */
  /*     .autoComplete_selector div[class*='MultiValueGeneric'] {
    color: var(--mainColor) !important;
  } */
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od *::-webkit-scrollbar-thumb {
  background-color: transparent !important;
  outline: medium none invert !important;
  outline: initial !important;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od *::-webkit-scrollbar {
  width: 0 !important;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od div[class*=control] {
  width: 100%;
  min-height: 30px;
  height: 30px;
  border: 1px solid var(--borderColor);
  background-color: var(--bgColor);
  padding: 0 10px;
  transition: 0.3s;
  font-size: 10px;
  border-radius: 0;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od div[class*=control] > div:first-child {
  height: 30px;
  overflow-y: scroll;
}
@media (max-width: 992px) {
  .ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od div[class*=control] > div:first-child {
    height: -webkit-max-content;
    height: max-content;
  }
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od div[class*=indicatorSeparator] {
  display: none;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od div[class*=indicatorContainer] {
  padding: 0;
  display: none;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od div[class*=control] {
  box-shadow: none;
  padding: 0;
}
@media (max-width: 992px) {
  .ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od div[class*=control] {
    height: -webkit-max-content;
    height: max-content;
  }
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od div[class*=control]:hover {
  background-color: var(--bgColor);
  box-shadow: none;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od div[class*=menu] {
  margin-top: 0;
  border-radius: 0;
  width: 100%;
  box-shadow: none;
  border: 1px solid var(--borderColor);
  z-index: 9999;
  color: var(--mainColor) !important;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od div[class*=menu] div {
  background-color: var(--bgColor);
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od div[class*=menu] div div {
  background-color: var(--bgColor);
  color: var(--mainColor);
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od div[class*=option] {
  padding: 5px;
  font-size: 12px;
  max-width: 100%;
  text-overflow: ellipsis;
  z-index: 999;
  white-space: nowrap;
  overflow: hidden;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .MuiSvgIcon-fontSizeSmall {
  font-size: 16px;
  color: var(--mainColor);
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .PrivateSwitchBase-root-4 {
  padding: 0;
  -webkit-margin-end: 5px;
          margin-inline-end: 5px;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od div[class*=option]:hover {
  background-color: var(--secondaryColor);
  color: #fff;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .Mui-checked .MuiSvgIcon-fontSizeSmall {
  color: #fff;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od div[class*=placeholder] {
  text-transform: capitalize;
  color: var(--mainColor) !important;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od div[class*=IndicatorsContainer] {
  display: none;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od div[class*=ValueContainer] div[class*=Input] {
  margin: 0;
  padding: 0;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od div[class*=large] input {
  width: 240px !important;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od div[class*=medium] input {
  width: 130px !important;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od div[class*=small] input {
  width: 72px !important;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .inputDisabled div[class*=control] {
  background-color: var(--borderColor);
  color: rgba(79, 79, 79, 0.5) !important;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .inputDisabled div[class*=multiValue] {
  opacity: 0.5;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .autoCompleteInput div[class*=singleValue] {
  color: var(--mainColor) !important;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .autoComplete_selector div[class*=singleValue] {
  color: var(--mainColor) !important;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .autoComplete_selector div[class*=multiValue] {
  background-color: var(--borderColor) !important;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .autoComplete_selector div[class*=multiValue] div {
  color: var(--mainColor) !important;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .autoCompleteInput div[class*=multiValue] {
  background-color: var(--borderColor) !important;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .autoCompleteInput div[class*=multiValue] div {
  color: var(--mainColor) !important;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .autoCompleteInput div[class*=multiValue] {
  color: var(--mainColor) !important;
  background-color: var(--borderColor) !important;
}
.ReactSelectAutocomplete_ReactSelectAutocomplete__6\\+1Od .autoCompleteInput div[class*=MultiValueGeneric] {
  color: var(--mainColor) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/app/components/Form/Inputs/ReactSelectAutocomplete/ReactSelectAutocomplete.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;AD2HE;EACE,WAAA;ACzHJ;AD4HE;EACE,kCAAA;AC1HJ;AD6HE;EACE,kCAAA;AC3HJ;;AAlDE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAqDJ;AApDI;EACE,0BAAA;AAsDN;AApDI;;EAEE,mBAAA;EDgGF,0BAAA;EC9FE,iBAAA;AAsDN;AApDI;EACE,4BAAA;AAsDN;AAnDE;EACE,wBAAA;AAqDJ;AApDI;EACE,wBAAA;AAsDN;AAnDE;EACE,+BAAA;AAqDJ;AAnDE;EACE,kBAAA;AAqDJ;AApDI;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,0BAAA;UAAA,yBAAA;AAsDN;AArDM;EACE,WAAA;EACA,YAAA;AAuDR;AAnDE;EACE,mCAAA;EACA,YAAA;AAqDJ;AAjDM;;;EAGE,2BAAA;UAAA,0BAAA;AAmDR;AA/CE;EA2BF;;;;;;;SAAA;EA0BI;;;;;;;KAAA;EA4GA;;KAAA;AA7FJ;AAnEI;EACE,wCAAA;EACA,sCAAA;EAAA,2BAAA;AAqEN;AAnEI;EACE,mBAAA;AAqEN;AAlEI;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,oCAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAoEN;AAnEM;EACE,YAAA;EACA,kBAAA;AAqER;ADSE;EChFI;IAII,2BAAA;IAAA,mBAAA;EAuER;AACF;AA5DI;EACE,aAAA;AA8DN;AA5DI;EACE,UAAA;EACA,aAAA;AA8DN;AA5DI;EACE,gBAAA;EACA,UAAA;AA8DN;ADPE;ECzDE;IAII,2BAAA;IAAA,mBAAA;EAgEN;AACF;AA/DM;EACE,gCAAA;EACA,gBAAA;AAiER;AAtDI;EACE,aAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,oCAAA;EACA,aAAA;EACA,kCAAA;AAwDN;AAvDM;EACE,gCAAA;AAyDR;AAxDQ;EACE,gCAAA;EACA,uBAAA;AA0DV;AAtDI;EACE,YAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AAwDN;AAtDI;EACE,eAAA;EACA,uBAAA;AAwDN;AAtDI;EACE,UAAA;EACA,uBAAA;UAAA,sBAAA;AAwDN;AAtDI;EACE,uCAAA;EACA,WAAA;AAwDN;AApDM;EACE,WAAA;AAsDR;AAnDI;EACE,0BAAA;EACA,kCAAA;AAqDN;AAnDI;EACE,aAAA;AAqDN;AAhDM;EACE,SAAA;EACA,UAAA;AAkDR;AA9CM;EACE,uBAAA;AAgDR;AA5CM;EACE,uBAAA;AA8CR;AA1CM;EACE,sBAAA;AA4CR;AAzCI;EAEE,oCAAA;EACA,uCAAA;AA0CN;AAvCI;EACE,YAAA;AAyCN;AAvCI;EACE,kCAAA;AAyCN;AAvCI;EACE,kCAAA;AAyCN;AAvCI;EACE,+CAAA;AAyCN;AAxCM;EACE,kCAAA;AA0CR;AAvCI;EACE,+CAAA;AAyCN;AAxCM;EACE,kCAAA;AA0CR;AApCI;EACE,kCAAA;EACA,+CAAA;AAsCN;AApCI;EACE,kCAAA;AAsCN","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n\n.ReactSelectAutocomplete {\n  .label {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    label {\n      text-transform: capitalize;\n    }\n    label,\n    p {\n      margin-bottom: 10px;\n      @include fontSize(12);\n      line-height: 15px;\n    }\n    p {\n      color: var(--secondaryColor);\n    }\n  }\n  .labelError {\n    color: var(--errorColor);\n    p {\n      color: var(--errorColor);\n    }\n  }\n  .error {\n    border-color: var(--errorColor);\n  }\n  .input {\n    position: relative;\n    .icon {\n      position: absolute;\n      z-index: 1;\n      top: 50%;\n      transform: translateY(-50%);\n      margin-inline-start: 10px;\n      svg {\n        width: 10px;\n        height: 10px;\n      }\n    }\n  }\n  .inputError {\n    border: 1px solid var(--errorColor);\n    padding: 1px;\n  }\n  .iconInput {\n    :global {\n      div[class*='control'],\n      div[class*='control'],\n      div[class*='control'] {\n        padding-inline-start: 25px;\n      }\n    }\n  }\n  :global {\n    *::-webkit-scrollbar-thumb {\n      background-color: transparent !important;\n      outline: unset !important;\n    }\n    *::-webkit-scrollbar {\n      width: 0 !important;\n    }\n\n    div[class*='control'] {\n      width: 100%;\n      min-height: 30px;\n      height: 30px;\n      border: 1px solid var(--borderColor);\n      background-color: var(--bgColor);\n      padding: 0 10px;\n      transition: 0.3s;\n      font-size: 10px;\n      border-radius: 0;\n      & > div:first-child {\n        height: 30px;\n        overflow-y: scroll;\n        @include Sm {\n          height: max-content;\n        }\n      }\n    }\n/*     div[class*='ValueContainer'] {\n      height: 30px;\n      overflow-y: scroll;\n      // padding: 0;\n      @include Sm {\n        height: max-content;\n      }\n    } */\n    div[class*='indicatorSeparator'] {\n      display: none;\n    }\n    div[class*='indicatorContainer'] {\n      padding: 0;\n      display: none;\n    }\n    div[class*='control'] {\n      box-shadow: none;\n      padding: 0;\n      @include Sm {\n        height: max-content;\n      }\n      &:hover {\n        background-color: var(--bgColor);\n        box-shadow: none;\n      }\n    }\n    /*     div[class*='MenuList'] {\n      padding: 0;\n      background-color: var(--bgColor);\n      div {\n        background-color: var(--bgColor);\n        color: var(--mainColor);\n      }\n    } */\n    div[class*='menu'] {\n      margin-top: 0;\n      border-radius: 0;\n      width: 100%;\n      box-shadow: none;\n      border: 1px solid var(--borderColor);\n      z-index: 9999;\n      color: var(--mainColor) !important;\n      div {\n        background-color: var(--bgColor);\n        div {\n          background-color: var(--bgColor);\n          color: var(--mainColor);\n        }\n      }\n    }\n    div[class*='option'] {\n      padding: 5px;\n      font-size: 12px;\n      max-width: 100%;\n      text-overflow: ellipsis;\n      z-index: 999;\n      white-space: nowrap;\n      overflow: hidden;\n    }\n    .MuiSvgIcon-fontSizeSmall {\n      font-size: 16px;\n      color: var(--mainColor);\n    }\n    .PrivateSwitchBase-root-4 {\n      padding: 0;\n      margin-inline-end: 5px;\n    }\n    div[class*='option']:hover {\n      background-color: var(--secondaryColor);\n      color: #fff;\n    }\n\n    .Mui-checked {\n      .MuiSvgIcon-fontSizeSmall {\n        color: #fff;\n      }\n    }\n    div[class*='placeholder'] {\n      text-transform: capitalize;\n      color: var(--mainColor) !important;\n    }\n    div[class*='IndicatorsContainer'] {\n      display: none;\n    }\n    div[class*='ValueContainer'] {\n      // padding-inline-start: 25px;\n\n      div[class*='Input'] {\n        margin: 0;\n        padding: 0;\n      }\n    }\n    div[class*='large'] {\n      input {\n        width: 240px !important;\n      }\n    }\n    div[class*='medium'] {\n      input {\n        width: 130px !important;\n      }\n    }\n    div[class*='small'] {\n      input {\n        width: 72px !important;\n      }\n    }\n    .inputDisabled div[class*='control'] {\n      //  background-color: hsl(0deg, 0%, 95%);\n      background-color: var(--borderColor);\n      color: rgba(79, 79, 79, 0.5) !important;\n    }\n\n    .inputDisabled div[class*='multiValue'] {\n      opacity: 0.5;\n    }\n    .autoCompleteInput div[class*='singleValue'] {\n      color: var(--mainColor) !important;\n    }\n    .autoComplete_selector div[class*='singleValue'] {\n      color: var(--mainColor) !important;\n    }\n    .autoComplete_selector div[class*='multiValue'] {\n      background-color: var(--borderColor) !important;\n      div {\n        color: var(--mainColor) !important;\n      }\n    }\n    .autoCompleteInput div[class*='multiValue'] {\n      background-color: var(--borderColor) !important;\n      div {\n        color: var(--mainColor) !important;\n      }\n    }\n    /*     .autoComplete_selector div[class*='MultiValueGeneric'] {\n      color: var(--mainColor) !important;\n    } */\n    .autoCompleteInput div[class*='multiValue'] {\n      color: var(--mainColor) !important;\n      background-color: var(--borderColor) !important;\n    }\n    .autoCompleteInput div[class*='MultiValueGeneric'] {\n      color: var(--mainColor) !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `ReactSelectAutocomplete_scroll__KKW7L`,
	"ReactSelectAutocomplete": `ReactSelectAutocomplete_ReactSelectAutocomplete__6+1Od`,
	"label": `ReactSelectAutocomplete_label__2KLXs`,
	"labelError": `ReactSelectAutocomplete_labelError__I1AL9`,
	"error": `ReactSelectAutocomplete_error__Ap51A`,
	"input": `ReactSelectAutocomplete_input__GnoFA`,
	"icon": `ReactSelectAutocomplete_icon__slq6j`,
	"inputError": `ReactSelectAutocomplete_inputError__-22cR`,
	"iconInput": `ReactSelectAutocomplete_iconInput__nHvkz`
};
export default ___CSS_LOADER_EXPORT___;
